import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import SearchResources from "../resources/searchResources";
import FeaturedRecipes from "./featuredRecipes";
import SearchFoodNutrition from "../foodDatabase/searchFoodNutrition";
import { getAds, resetField } from "../../../store/actions";
import AdCarousel from "../../home/adCarousel";

const NutritionHome = ({ history, getAds, ads, resetField }) => {
	useEffect(() => {
		resetField("AddRecipe.recipeFoodSearchKeyword", null);
		getAds();
	}, [getAds, resetField]);

	const resourcesFooter = (
		<div
			className="text-primary-dark font-weight-bold px-4 py-3 pointer"
			onClick={() =>
				resetField("Resources.resourcesResult", {}, () => {
					history.push("/nutrition/resources");
				})
			}>
			View all articles!
		</div>
	);

	const recipeFooter = (
		<div className="text-primary-dark font-weight-bold pt-3 pointer" onClick={() => history.push("/nutrition/recipes")}>
			View and Search all recipes!
		</div>
	);

	const foodFooter = (
		<div
			className="text-primary-dark font-weight-bold pt-3 pointer"
			onClick={() => history.push("/nutrition/food-database")}>
			View and Search all Foods!
		</div>
	);
	const adList =
		ads &&
		ads.filter((item) => {
			return item.is_active === true;
		});

	return (
		<div className="page page-nutrition-home">
			<div className="container d-flex flex-column h-100 ">
				<div className="d-flex flex-column justify-content-between">
					<div className="row mb-4">
						<div className="col-4">
							<SearchResources
								history={history}
								title="Featured Articles"
								className="p-1"
								footer={resourcesFooter}
								highlightSelected={false}
							/>
						</div>
						<div className="col-4">
							<FeaturedRecipes history={history} footer={recipeFooter} />
						</div>
						<div className="col-4">
							<div className="mb-3">
								<AdCarousel ads={adList} height="250px" />
							</div>
							<div className="card card-primary w-100 p-4 border-0">
								<h4 className="text-primary-dark mb-3">Search Food Nutrition</h4>
								<SearchFoodNutrition
									footer={foodFooter}
									afterSearch={() => history.push("/nutrition/food-database")}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = {
	getAds,
	resetField
};

const mapStateToProps = (state) => {
	const { Resources, Home } = state;
	return {
		resourceList: get(Resources, "resourcesResult.results", []),
		foodNutritionList: get(state, "FoodDatabase.foodNutritionList", []),
		ads: get(Home, "ads", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NutritionHome);
